"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = require("../../../utils/styles/index");
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */

/* ++++++++++ --------------- EXPORT : LOADER : STYLES--------------- ++++++++++ */


var _default = {
  barchart: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'flex-end',
    padding: (0, _index.pxToEm)(20),
    width: function width(props) {
      return props.width ? (0, _index.replacePXinStringWithEM)(props.width) : 'fit-content';
    },
    height: function height(props) {
      return props.height ? (0, _index.replacePXinStringWithEM)(props.height) : (0, _index.pxToEm)(150);
    },
    '& .barelement': {
      marginRight: (0, _index.pxToEm)(10),
      '&:last-child': {
        marginRight: '0'
      }
    }
  }
};
exports.default = _default;